import { useState, useRef, useEffect } from "react";
import { createPortal } from "react-dom";
import { InfoIcon } from "lucide-react";
import "../../css/ChartInfoPopup.css";

export default function ChartInfoPopup({ text }) {
  const [open, setOpen] = useState(false);
  const triggerRef = useRef(null);
  const popupRef = useRef(null);
  const [pos, setPos] = useState({ top: 0, left: 0 });
  const [placement, setPlacement] = useState("top");

  // useEffect(() => {
  //   if (!open || !triggerRef.current) return;

  //   const updatePosition = () => {
  //     const rect = triggerRef.current.getBoundingClientRect();

  //     setPos({
  //       top: rect.top,
  //       left: rect.left + rect.width / 2,
  //     });
  //   };

  //   updatePosition();

  //   window.addEventListener("scroll", updatePosition, true);
  //   window.addEventListener("resize", updatePosition);

  //   return () => {
  //     window.removeEventListener("scroll", updatePosition, true);
  //     window.removeEventListener("resize", updatePosition);
  //   };
  // }, [open]);

  useEffect(() => {
    if (!open || !triggerRef.current || !popupRef.current) return;

    const updatePosition = () => {
      const trigger = triggerRef.current.getBoundingClientRect();
      const popup = popupRef.current.getBoundingClientRect();
      const vw = window.innerWidth;
      const vh = window.innerHeight;
      const margin = 8;

      let top = trigger.top - popup.height - margin;
      let left = trigger.left + trigger.width / 2;
      let place = "top";

      // 🔼 Not enough space above → place bottom
      if (top < margin) {
        top = trigger.bottom + margin;
        place = "bottom";
      }

      // ◀️ Prevent left overflow
      if (left - popup.width / 2 < margin) {
        left = popup.width / 2 + margin;
      }

      // ▶️ Prevent right overflow
      if (left + popup.width / 2 > vw - margin) {
        left = vw - popup.width / 2 - margin;
      }

      setPlacement(place);
      setPos({ top, left });
    };

    updatePosition();

    window.addEventListener("scroll", updatePosition, true);
    window.addEventListener("resize", updatePosition);

    return () => {
      window.removeEventListener("scroll", updatePosition, true);
      window.removeEventListener("resize", updatePosition);
    };
  }, [open]);

  useEffect(() => {
    const close = (e) => {
      if (
        popupRef.current &&
        !popupRef.current.contains(e.target) &&
        !triggerRef.current.contains(e.target)
      ) {
        setOpen(false);
      }
    };
    document.addEventListener("click", close);
    return () => document.removeEventListener("click", close);
  }, []);

  return (
    <>
      <span ref={triggerRef} className="chart-info-trigger d-flex">
        <InfoIcon
          size={18}
          onClick={() => setOpen(!open)}
          className="chart-info-icon"
        />
      </span>

      {open &&
        createPortal(
          // <div
          //   ref={popupRef}
          //   className="chart-info-popup portal ak-text-sm"
          //   style={{
          //     top: `${pos.top}px`,
          //     left: `${pos.left}px`,
          //   }}
          // >
          <div
            ref={popupRef}
            className={`ak-text-sm chart-info-popup portal ${placement}`}
            style={{
              top: `${pos.top}px`,
              left: `${pos.left}px`,
            }}
          >
            {text}
            <div className="chart-info-arrow" />
          </div>,
          document.body
        )}
    </>
  );
}
